import { defineStore } from "pinia";
import userInfos from "@/utils/userInfos";
import {
  getAccessToken,
  getRefreshToken,
  setTokens,
  clearTokens,
} from "@/utils/tokenService";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: userInfos.getUserInfos(),
    accessToken: getAccessToken(),
    refreshToken: getRefreshToken(),
    estaRenovando: false,
  }),

  getters: {
    isAutenticado: (state) => !!state.accessToken,
    userScope: (state) => state.user?.scope || "usuarioNaoLogado",
    hasRole: (state) => (role) => {
      if (!state.user) return false;

      const scopeStr =
        typeof state.user.scope === "string" ? state.user.scope : "";
      const scopes = scopeStr
        .split(" ")
        .filter(Boolean)
        .map((scope) => scope.replace(/^SCOPE_/, "").trim());

      const regrasList = Array.isArray(state.user.regras)
        ? state.user.regras.map((r) => (typeof r === "string" ? r : r.nome))
        : [];

      const authList = Array.isArray(state.user.authorities)
        ? state.user.authorities.map((a) =>
            typeof a === "string" ? a : a.authority
          )
        : [];

      const allRoles = [...scopes, ...regrasList, ...authList]
        .filter(Boolean)
        .map((r) =>
          r
            .replace(/^SCOPE_/, "")
            .replace(/^ROLE_/, "")
            .trim()
        );

      return allRoles.includes(role);
    },
  },

  actions: {
    atualizarSessao(novoAccess, novoRefresh) {
      setTokens(novoAccess, novoRefresh);
      this.accessToken = novoAccess;
      this.refreshToken = novoRefresh;
      this.user = userInfos.getUserInfos(); // Atualiza os dados (nome, exp, scope)
    },
    finalizarSessao() {
      clearTokens();
      this.accessToken = null;
      this.refreshToken = null;
      this.user = null;
    },
  },
});
